import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { SubjectService } from "../../services/SubjectService";
import { MULTI, SINGLE, Selector } from "./Selector";

export const SubjectSelect = ({
  selectHandler,
  selectedSubjects,
  size,
  isRequired,
  creation_method,
  isSingle = false,
  withExternalContext = false,
}) => {
  const [subjects, setSubjects] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(
    isSingle && selectedSubjects && selectedSubjects.length > 0
      ? selectedSubjects[0]
      : ""
  );

  useEffect(() => {
    SubjectService.getSubjects({ withExternalContext, allSubjects: true }).then(
      (subjects) => {
        // filter here for now, maybe it should be done on the server side
        if (creation_method) {
          subjects = subjects.filter((subject) => {
            return (
              (creation_method === "fetched" && !subject.creation_method) ||
              subject.creation_method === creation_method
            );
          });
        }
        setSubjects(
          subjects.map((subject) => {
            return {
              id: subject.id + "",
              title: subject.title,
              name: subject.name,
              label: subject.name,
            };
          })
        );
      }
    );
  }, []);

  const selectHandlerWrapper = (selectedSubjectsId) => {
    if (isSingle) {
      setSelectedItemId(selectedSubjectsId);
    }
    selectHandler(
      subjects.filter((subject) => {
        return isSingle
          ? selectedSubjectsId === subject.id
          : selectedSubjectsId.includes(subject.id);
      })
    );
  };

  return (
    <Selector
      type={isSingle ? SINGLE : MULTI}
      id={"subject-select"}
      label={t("subject.selector") + (isRequired ? "*" : "")}
      size={size || "medium"}
      options={subjects}
      selectHandler={selectHandlerWrapper}
      selectedOptions={selectedSubjects}
      selectedItemId={selectedItemId}
    />
  );
};
